import { useMutation, UseMutationResult, useQuery } from 'react-query'
import { getSolarData, getSolarDataLists } from './functions'
import { isNil } from 'lodash/fp'

export const useGetSolarDataLists = (
  partner: string,
  hash: string,
  accessKey: string | null | undefined
): {
  isLoading: boolean
  data: Array<{ name: string; key: string }> | undefined
} => {
  const { data, isLoading } = useQuery({
    queryKey: ['solarDataLists', partner, hash, accessKey],
    queryFn: async () =>
      isNil(accessKey)
        ? undefined
        : await getSolarDataLists(partner, hash, accessKey)
  })
  return { isLoading, data }
}
export const useGetSolarData = (): UseMutationResult<
  { name: string; data: Buffer } | undefined,
  undefined,
  {
    partner: string
    hash: string
    name: string
    key: string
    accessKey: string
  }
> => {
  return useMutation({
    mutationFn: async (args: {
      partner: string
      hash: string
      name: string
      key: string
      accessKey: string
    }): Promise<{ name: string; data: Buffer } | undefined> => {
      const { partner, hash, name, key, accessKey } = args
      return await getSolarData(partner, hash, name, key, accessKey)
    }
  })
}
